import React, { useState } from 'react';
import { Formik } from 'formik';
import { Box } from 'atoms';
import { RCTable } from 'components';
import { useQueryParams } from 'hooks';
import { DownloadReportsTableConfig, DriverListQueries } from 'utils';
// import { FileTypesOptions } from 'utils/config';
import { getDriverList } from 'store/driverSlice';

export default function DownloadReports() {
	const [rowData, setRowData] = useState({});
	const [paginateConfig, setpaginateConfig] = useQueryParams({
		search_type: 'download_task',
		filterQuery: DriverListQueries,
		persistKey: 'downloadReports:filters',
	});
	return (
		<Formik>
			<Box mt={3}>
				<RCTable
					rowKey="id"
					tableDatas={[rowData, setRowData]}
					togglePaginate={[paginateConfig, setpaginateConfig]}
					dispatchAction={getDriverList}
					columns={DownloadReportsTableConfig}
				/>
			</Box>
		</Formik>
	);
}
